export default "__VITE_ASSET__284340e8__"